export default __webpack_public_path__ + "static/media/frame_zh_tw_sp.4cf2da81.png";